import React from 'react';

import Text from '/component/base/Text';
import {ManageMySiteTestIDs} from '/constant/TestIDs';
import {getTextFromReactNode} from '/util/accessibility.util';

import {StaticFocusable} from '../../sections/StaticFocusable';

import {styles} from './FieldGroup.style';
import type {FieldGroupProps} from './FieldGroup.types';

const {fieldGroup} = ManageMySiteTestIDs;

const getSafeLabel = (label: React.ReactNode): string => {
  try {
    const raw = getTextFromReactNode(label);
    return typeof raw === 'string' ? raw : '';
  } catch {
    return '';
  }
};

export const FieldGroup = ({label = '', value = ''}: FieldGroupProps) => {
  const safeLabel = getSafeLabel(label);
  const safeValue = String(value ?? '');

  const valueAccessibilityLabel = safeValue
    ? safeLabel
      ? `${safeValue}, ${safeLabel}`
      : safeValue
    : safeLabel
    ? `${safeLabel}, not provided`
    : 'Not provided';

  return (
    <>
      <StaticFocusable label={safeLabel} testID={fieldGroup.label(safeLabel)}>
        <Text
          style={styles.fieldLabel}
          allowFontScaling
          maxFontSizeMultiplier={2}
          accessible={false}
          testID={fieldGroup.labelText(safeLabel)}>
          {label}
        </Text>
      </StaticFocusable>

      <StaticFocusable
        label={valueAccessibilityLabel}
        testID={fieldGroup.value(safeValue || safeLabel)}>
        <Text
          style={styles.fieldValue}
          allowFontScaling
          maxFontSizeMultiplier={2}
          accessible={false}
          testID={fieldGroup.valueText(safeValue || safeLabel)}
          isBold>
          {value}
        </Text>
      </StaticFocusable>
    </>
  );
};

export default FieldGroup;
